import { Component } from '@angular/core';

@Component({
  selector: 'ngx-audio',
  template: `
    <router-outlet></router-outlet>
  `,
})
export class AudioComponent {
}